import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=3ea0adcb&scoped=true&"
import script from "./PluginList.vue?vue&type=script&lang=js&"
export * from "./PluginList.vue?vue&type=script&lang=js&"
import style0 from "./PluginList.vue?vue&type=style&index=0&id=3ea0adcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0adcb",
  null
  
)

export default component.exports